module.exports = __webpack_public_path__ + "img/checked_color_on.95bf0c05.svg";